import { Avatar as BaseAvatar } from '@base-ui/react/avatar';
import { cn } from '../../lib/cn';

/** Инициалы: первые буквы двух первых слов имени, иначе — первая буква email. */
export function initialsOf(name: string | null | undefined, email?: string): string {
  const words = (name ?? '').trim().split(/\s+/).filter(Boolean);
  const letters = words.slice(0, 2).map((word) => word[0] ?? '');
  const result = letters.join('') || (email?.[0] ?? '?');
  return result.toUpperCase();
}

interface AvatarProps {
  name: string | null | undefined;
  email?: string;
  /** Адрес аватара (presigned URL из профиля); без него — инициалы. */
  src?: string | null;
  size?: 'sm' | 'md';
  className?: string;
}

export function Avatar({ name, email, src, size = 'md', className }: AvatarProps) {
  return (
    <BaseAvatar.Root
      className={cn(
        'inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-accent font-semibold text-accent-foreground select-none',
        size === 'sm' ? 'size-6 text-2xs' : 'size-9 text-xs',
        className,
      )}
    >
      {src != null && <BaseAvatar.Image src={src} alt="" className="size-full object-cover" />}
      <BaseAvatar.Fallback>{initialsOf(name, email)}</BaseAvatar.Fallback>
    </BaseAvatar.Root>
  );
}
